import type { Zorm } from 'react-zorm';
import { z } from 'zod';

const SignInFormSchema = z.object({
	custom: z.string().optional(),
	email: z
		.string()
		.email('Not a valid email...')
		.transform((email) => email.toLowerCase()),
	password: z.string().min(8, 'Use a longer password...'),
	redirectTo: z.string().optional(),
});

export default SignInFormSchema;

export type SignInFormSchemaZormType = Zorm<typeof SignInFormSchema>;
